<template>
  <!-- <div class="chat flex flex-direction-column">
    <div class="flex-grow-1 chatContent"> -->
  <div class="chat">
    <div class="chatContent">
      <chatContent ref="chatContent" @getNewResult="getNewResult"></chatContent>
    </div>
    <div class="chat-bottom">
      <div :class="['robot', {'no-click': refresh}]" @click="pushTalkNode">
        <div class="robot-bubble" v-if="false && bubbleStatus">点击我，展示常见问题~</div>
        <img :src="require('@/assets/qa7.png')" alt="">
        <div class="bgwhite" v-if="!inputFlag"></div>
      </div>
      <chatInput ref="chatInput" @send="_send" @over="_over" @getNextNode="_getNextNode" @onFocus="_onFocus" @toInfo="_toInfo"></chatInput>
    </div>
  </div>
</template>

<script>
import chatInput from "@/components/chatInput.vue";
import chatContent from "@/components/chatContent.vue";
export default {
  name: "HomeView",
  data() {
    return {
      historyList: [],
      inputFlag: false,
      bubbleStatus: true,
      refresh: false
    };
  },
  watch: {
    '$store.state.nextNode': {
      handler(newVal,oldVal){
        this.inputFlag = newVal.length > 0 ? true :  false
      },
      deep: true,
    },
    '$store.state.bubbleStatus': {
      handler(newVal,oldVal){
        this.bubbleStatus = newVal
      },
      deep: true,
    },
    '$store.state.loadingState': {
      handler(newVal,oldVal){
        this.refresh = newVal
      },
      deep: true,
    },
  },
  components: {
    chatInput,
    chatContent,
  },
  created() {
    this.auth();
  },
  methods: {
    auth() {
      let code = this.$route.query.code ? this.$route.query.code : 123;
      this.$axios.post("/conversation/auth?openId=" + code).then((res) => {
        if (res.status == 0) {
          localStorage.setItem("token", res.content.token);
          localStorage.setItem("user", JSON.stringify(res.content));
          this.$refs.chatContent.getConversationHello();
        }
      });
    },

    getNewResult(e) {
      this.$refs.chatInput.getDefaultQuestion(e);
    },
    pushTalkNode() {
      this.$refs.chatContent.pushTalkNode();
      this.$store.commit('SET_BUBBLE', false);
    },
    _toInfo(e) {
      this.$refs.chatContent._send(e);
    },
    _send(e) {
      this.$refs.chatContent.sendMessage(e);
    },
    _getNextNode(e) {
      this.$refs.chatContent.getNextNode(e);
    },
    _onFocus(e) {
      this.$refs.chatContent.onFocus(e);
    },
    _over(e) {
      this.$refs.chatContent.systemInfo({ type: "over" });
    },
  },
};
</script>
<style lang="scss" scoped>
.no-click {
  pointer-events: none;
}
.chatContent {
  overflow: hidden;
  // background-color: #fff;
}
.chat-bottom{
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 999;
  .robot{
    width: 65px;
    position: absolute;
    height: 82px;
    top: -20px;
    .robot-bubble{
      display: inline-block;
      padding: 8px 10px;
      position: absolute;
      background-color: #f5f6f8;
      border-radius: 4px;
      font-size: 12px;
      box-shadow: 0 0 5px #f5f6f8;
      margin-bottom: 15px;
      right: -140px;
      top: -30px;
      &::before {
        position: absolute;
        top: 24px;
        left: -9px;
        width: 0;
        height: 0;
        border-top: 12px solid transparent;
        content: "";
        border-right: 13px solid #f5f6f8;
        transform: rotate(-20deg);
      }
    }
  }
  .bgwhite{
    position: absolute;
    bottom:0;
    height: 14px;
    background: #fff;
    width: 100%;
    z-index: 999;
  }
  img{
    width: 65px;
    position: absolute;
    // top: -25px;
    z-index: 999;
    &.img-top {
      z-index: 999;
    } 
  }
}

.chat {
  height: 100%;
  width: 100%;
}
</style>